import { Suspense } from 'react';
import { ActivityClient } from './activity-client';

export const metadata = { title: 'Activity · Admin' };

export default function Page() {
  return (
    <Suspense fallback={null}>
      <ActivityClient />
    </Suspense>
  );
}
